import Uid from '../lib/uid'

const uid = new Uid(3)

const DEFAULT_FIELDS = {
  id: null,
  authorId: null,
  title: '',
  // subtitle: undefined,
  sections: [],
  tags: '',
}

export default class Post {
  static nextId() {
    return uid.getId()
  }

  constructor({
    id,
    authorId,
    title = '',
    tags = '',
    subtitle = undefined,
    sections = undefined,
  }) {
    Object.assign(this, DEFAULT_FIELDS)
    this.id = id || `${uid.getId()}-post`
    this.authorId = authorId
    this.title = title
    this.tags = tags
    if (subtitle) this.subtitle = subtitle
    if (sections) this.sections = this.sections.concat(sections)
  }

  toJson() {
    console.log('Post.toJson', this)
    return {
      id: this.id,
      authorId: this.authorId,
      title: this.title,
      subtitle: this.subtitle,
      tags: this.tags,
      sections: this.sections.map(s =>
        typeof s.toJson === 'function' ? s.toJson() : s,
      ),
    }
  }
}
